import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useGlobusHealth } from '../lib/globusHealth';

/**
 * Amber upstream-degraded banner (integration contract — degraded mode is
 * explicitly called out as NOT OPTIONAL). Fires when the CLIENT is online but
 * the server's live `globus` health indicator reports the Hub unreachable —
 * see lib/globusHealth.ts and health.service.ts. Mutations are blocked
 * centrally in lib/api.ts while this is active; this banner is the visible
 * half of that gate.
 */
export default function DegradedBanner() {
  const { degraded, lastChecked } = useGlobusHealth();
  const queryClient = useQueryClient();
  const wasDegraded = useRef(false);

  useEffect(() => {
    if (wasDegraded.current && !degraded) {
      // Recovered — cached reads may be stale from the outage window.
      void queryClient.invalidateQueries();
    }
    wasDegraded.current = degraded;
  }, [degraded, queryClient]);

  if (!degraded) return null;
  return (
    <div className="netbanner degraded" role="status">
      Some services are temporarily unavailable. Data shown may not be current and changes can't be
      saved right now — we're checking automatically every 30 seconds.
      {lastChecked && ` Last checked ${lastChecked.toLocaleTimeString()}.`}
    </div>
  );
}
